import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { TableStore } from '../components/table2/table_store'
import { NegativeTargetsTable } from '../components/targets/NegativeTargetsTable'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const NegativeTargets = observer(({}) => {
    const { profile } = useUser()
    const savedFiltersStore = useSavedFiltersStore()
    const [store] = useState(new TableStore<any>(userStore, 'negative targets'))

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/negative-targets', params, true)
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)

    return (
        <NegativeTargetsTable
            store={store}
            savedFiltersStore={savedFiltersStore}
            tableHooks={tableHooks}
        />
    )
})
